import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Loading from 'vue-loading-overlay';
import { VueEditor } from "vue2-editor";
import Vuex from 'vuex'
import store from './store';

Vue.config.productionTip = false

import Parse from 'parse'
import './parse'
import './components'
import './subComponents'
import './moment'
import './plugin/Currency'
import './plugin/Arabic'
import './plugin/ImageUrl'
//import style
import './assets/scss/main.scss';
import './assets/componentStyle/horganice-cid-reader.scss'
import "vue-loading-overlay/dist/vue-loading.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(Vuex)
Vue.use(Loading)
Vue.component('vue-editor', VueEditor)

Vue.prototype.$sessionToken = ""
Vue.prototype.$user = null
Vue.prototype.$apartmentId = ""
Vue.prototype.$apartment = null
Vue.prototype.$adminUser = process.env.VUE_APP_ADMIN_USER
Vue.prototype.$adminPass = process.env.VUE_APP_ADMIN_PASS
Vue.prototype.$webAppUrl = process.env.VUE_APP_WEBAPP_URL
Vue.config.errorHandler = function(err, vm, info) {
  console.log(err);
  if (err.code === 209 || (err.message && err.message.toLowerCase() === 'invalid session token')) {
    localStorage.removeItem(`Parse/${process.env.VUE_APP_APP_KEY}/currentUser`)
    try { Parse.User.logOut() } catch (e) { /* already invalid */ }
    setTimeout(() =>{
      window.location.href = window.location.origin
    },200)
  }
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
